import styled from 'styled-components';
import Button, { ButtonGroup } from '@omilia/button';

export const SFooterButton = styled(Button)`
  &&& {
    border-radius: 4px;

    :focus {
      box-shadow: none;
    }
  }
`;

export const SButtonGroup = styled(ButtonGroup)`
  justify-content: flex-end;
  padding-top: 32px;
`;
